import { render, staticRenderFns } from "./JobseekerRow.vue?vue&type=template&id=dfcd26c2&scoped=true&"
import script from "./JobseekerRow.vue?vue&type=script&lang=js&"
export * from "./JobseekerRow.vue?vue&type=script&lang=js&"
import style0 from "./JobseekerRow.vue?vue&type=style&index=0&id=dfcd26c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcd26c2",
  null
  
)

export default component.exports